import { createContext } from 'react';

import type { ProjectConfigOutput } from '#core/schema/ProjectConfigSchema.ts';

export interface ProjectContextProps {
  config: ProjectConfigOutput;
}

export const ProjectContext = createContext<ProjectContextProps>({} as ProjectContextProps);
